import { 
  SET_SEARCH_CONTROLS,
  UPDATE_SEARCH_CONTROLS,
  RESET_SEARCH_CONTROLS,
  TOGGLE_ADVANCED_SEARCH_CONTROLS
} from '../../constants/actions';
import { setSearchControlsToStorage } from '../../assets/helpers/searchHelper';
import { deepCopy } from '../../assets/helpers/utils';

const initialState = {
  currentControls: {},
  oldControls: {},
  showAdvancedControls: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_SEARCH_CONTROLS:
      // console.log('SET SEARCH CONTROLS REDUCER', state, action.data);
      const { data } = action;
      const obj = {...state, oldControls: {...deepCopy(data)}, currentControls: {...deepCopy(data)}}
      setSearchControlsToStorage(data);
      return obj;
    case UPDATE_SEARCH_CONTROLS:
      // console.log('UPDATE SEARCH CONTROLS REDUCER', state, action.data);
      const { currentControls } = state;
      const { key, value } = action.data;
      currentControls[key].value = value;
      return {...state, currentControls};
    case RESET_SEARCH_CONTROLS:
      // console.log('RESET SEARCH CONTROLS REDUCER', action, state);
      const { oldControls } = state;
      setSearchControlsToStorage(oldControls);
      return {...state, currentControls: deepCopy(oldControls)};
    case TOGGLE_ADVANCED_SEARCH_CONTROLS:
      return {...state, showAdvancedControls: !state.showAdvancedControls};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/searchControls.js